import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  "MuiBox-root": {
    margin: 20,
  },
  mainHeading: {
    padding: theme.spacing(2.5, 0, 2.5, 0),
  },
  buttonWidth: {
    width: "188px",
  },
  table: {
    minWidth: 1000,
    overflow: "auto",
  },
  tableHeader: {
    height: "56px",
    fontSize: "16px",
    fontWeight: 600,
    // color:'black'
  },
  tableHeadCell: {
    fontSize: "16px",
    fontWeight: "bold",
    // color: 'black',
  },
  starRating: {
    color: `${theme.agentTheme.shade.starRating} !important`,
  },
  myCustomersPaper: {
    boxShadow: "1px 3px 12px rgba(0, 0, 0, 0.08)",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    [theme.breakpoints.down("sm")]: {
      boxShadow: "-3px -5px 12px rgb(0 0 0 / 8%)",
      overflow: "auto",
    },
  },
  overviewText: {
    color: theme.agentTheme.card.foreground,
  },
  leftDiv: {
    width: "70%",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "auto",
      marginRight: "auto",
      width: "90%",
    },
  },
  rightDiv: {
    width: "27%",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "auto",
      marginRight: "auto",
      width: "90%",
      marginTop: "20px",
    },
  },
  paddedCards: {
    boxShadow: "rgba(0, 0, 0, 0.04) 0px 3px 5px",
    borderRadius: "8px",
    background: theme.agentTheme.card.main,
  },
  viewDetails: {
    color: theme.agentTheme.card.link_foreground,
    cursor: "pointer",
    "&:hover": {
      color: theme.agentTheme.primary.main,
    },
  },
  rightCards: {
    boxShadow: "rgba(0, 0, 0, 0.04) 0px 3px 5px",
    borderRadius: "8px",
    padding: theme.spacing(1.5, 3, 1.5, 3),
    cursor: "pointer",
  },
  bookButtonSize: {
    width: "188px",
    height: "40px",
  },
  upperSpaceDiv: {
    paddingTop: "3%",
    marginTop: "auto",
  },
  downloadIcon: {
    // color:'#384E89',
    cursor: "pointer",
  },
  rowItem: {
    cursor: "pointer",
    background: theme.agentTheme.card.main,
  },
  progressColor: {
    color: theme.palette.text.primary,
  },
  // loader:{
  //   display:'flex',
  //   justifyContent:'center',
  //   alignItems:'center',
  //   marginTop:'30px'
  // },
  timeText: {
    fontSize: "12px",
    textDecoration: "underline",
    color: theme.palette.primary.main,
    fontWeight: 500,
    cursor: "pointer",
  },
  multipleAirlineCount: {
    fontSize: "11px",
    paddingLeft: "6px",
    fontWeight: "bolder",
    color: "#384E89",
  },
  cellPadding: {
    padding: "16px 24px 16px 24px",
  },
  paginationData: {
    boxShadow: "1px 3px 12px rgba(0, 0, 0, 0.08)",
    textAlign: "center",
    display: "flex",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    justifyContent: "center",
  },
  noBookings: {
    boxShadow: "1px 3px 12px rgba(0, 0, 0, 0.08)",
    borderRadius: "12px",
  },
  loaderClass: {
    display: "flex",
    justifyContent: "center",
    boxShadow: "1px 3px 12px rgba(0, 0, 0, 0.08)",
    margin: theme.spacing(3, 0, 3, 0),
    height: "150px",
    borderRadius: "8px",
  },
  flex: {
    display: "flex",
    [theme.breakpoints.down("md")]: {
      flexWrap: "wrap",
    },
  },
  gap10: {
    gap: 10,
  },
  justifyCenter: {
    justifyContent: "center",
  },
  width70Container: {
    width: "70%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  width30Container: {
    width: "30%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
}));

export default useStyles;
